<script>
    import { forEach, head } from 'lodash'
    import Popper from 'popper.js'
    import { VueMixin, modalClose } from "../utility"
    import MyEventsCalculation from './MyEventsCalculation.vue'
    import { loading } from '../core/page-loader'
    import PdfSelector from '../eventcalculator/inline-components/PdfSelector.vue'
    

    export default {
        components: {MyEventsCalculation, PdfSelector},
        mixins: [VueMixin],
        props: [
            'container', 
            'availableCalculations'
        ],
        data() {
            return {
                selectedCalculationToAdd: null,
                pdfs: [],
                showDropDownMenu: false
            }
        },
        computed: {
            sumOfAllCalculations() {
                let sum = 0
                forEach(this.container.calculations, function (calculation) {
                    sum = sum + calculation.cost_cache
                })

                return this.currencyFormatter(sum)
            }
        },
        mounted() {
            this.initPopperMenu()
            this.selectFirstElementForCalcToAdd()
        },
        methods: {
            generatePdf() {
                this.$event.$emit('generate-pdf', {
                    id: this.container.id,
                    type: '\\App\\CalculationContainer'
                })
            },
            bindCalculationToContainer() {
                loading(true)
                axios.post('/calculation/to/container', {
                    calculation_id: this.selectedCalculationToAdd,
                    container_id: this.container.id
                }).then(() => {
                    this.$emit('calculation-was-bind')
                })
            },
            deleteContainer() {
                loading(true)
                axios.delete('/calculation/container/'+this.container.id).then(() => {
                    this.$emit('container-was-deleted')
                })
            },
            changeName() {
                let nameModal = $('#container-name-modal'),
                    nameInput = $('#container-name-input'),
                    nameConfirm = $('#name-container-confirm'),
                    closeIconsModal = $('.modal-close', nameModal)

                nameInput.val(this.container.name)
                nameConfirm.one('click', () => {
                    this.container.name = nameInput.val()

                    loading(true)
                    axios.post('/calculation/container/'+this.container.id+'/change-name', {
                        name: this.container.name
                    }).then(() => {
                        loading(false)
                    }).catch(() => {
                        loading(false)
                    })

                    modalClose()
                    nameConfirm.off()
                    closeIconsModal.off()
                })

                $('.modal-close').on('click', () => {
                    nameConfirm.off()
                    closeIconsModal.off()
                })

                nameModal.addClass('active')
            },
            initPopperMenu() {
                let onPopper = this.$el.querySelector('.menu-popper-container'),
                    reference = this.$el.querySelector('.mini-burger-btn')
                    
                new Popper(reference, onPopper, {
                    placement: 'bottom'
                })
            },
            toggleDropdownMenuListener(e) {
                if(e.target.parentElement.className !== 'menu-popper' && !this.firstTime)  {
                    this.showDropDownMenu = false

                    document.removeEventListener('click', this.toggleDropdownMenuListener)

                }
                
                this.firstTime = false
            },
            toggleDropdownMenu() {
                this.firstTime = true

                this.showDropDownMenu = !this.showDropDownMenu

                if(this.showDropDownMenu) {
                    document.addEventListener("click", this.toggleDropdownMenuListener, false)
                }
            },
            selectFirstElementForCalcToAdd() {
                this.$nextTick(function() {
                    if(Object.values(this.availableCalculations).length > 0) {
                        let headCalc = head(Object.values(this.availableCalculations))

                        this.selectedCalculationToAdd = headCalc.id
                    }
                })
                
            }
        },
        template: '#calculation-container-template',
    }
</script>